import React, { useState, useEffect } from "react";
import "./Search.scss";
import useDebounce from "../../utils/debounce";
import { useStoreActions, useStoreState } from "easy-peasy";

const className = "search";

const Search = () => {
  const rent = useStoreState((state) => state.rent.rent);
  const city = useStoreState((state) => state.rent.city2);
  const getRent = useStoreActions((actions) => actions.rent.getRent);
  const [value, setValue] = useState("");

  const debouncedSearchTerm = useDebounce(value, 700);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getRent(value);
    } else {
      getRent();
    }
  }, [debouncedSearchTerm]);

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  return (
    <div className={className + "-main"}>
      <input type="text" value={value} onChange={handleInput} />
    </div>
  );
};

export default Search;
